export default "__VITE_ASSET__4bf62efa__"